export default "__VITE_ASSET__773194ad__"